export default "__VITE_ASSET__C7$86jeS__"